import React, { Component } from 'react';
import mainLogo from '../assets/dogIcon.svg';
import { Container } from 'bloomer/lib/layout/Container';
import { NavbarBrand } from 'bloomer/lib/components/Navbar/NavbarBrand';
import { NavbarItem } from 'bloomer/lib/components/Navbar/NavbarItem';
import { Link } from '@reach/router';
import { NavbarBurger } from 'bloomer/lib/components/Navbar/NavbarBurger';
import { NavbarMenu } from 'bloomer/lib/components/Navbar/NavbarMenu';
import { NavbarStart } from 'bloomer/lib/components/Navbar/NavbarStart';
import { NavbarEnd } from 'bloomer/lib/components/Navbar/NavbarEnd';
import { NavbarDropdown } from 'bloomer/lib/components/Navbar/NavbarDropdown';
import Conditional from './Conditional';
import User from '../Entities/User';
import styled from 'styled-components';
import { Navbar } from 'bloomer';
import { Button } from 'bloomer/lib/elements/Button';

interface PropTypes {
  user: User;
}

interface StateTypes {
  active: boolean;
}

const NavInvisibleOnPrint = styled(Navbar)`
  @media print {
    display: none;
  }
`;

const NoButton = styled(Button)`
  &.button {
    background: transparent;
    border: none;
    color: white;
    &:hover {
      background: white;
      color: black;
    }
  }
`;

class Nav extends Component<PropTypes, StateTypes> {
  state = {
    active: false,
  };

  toggleActive = () => {
    this.setState({
      active: !this.state.active,
    });
  };

  render() {
    const { active } = this.state;
    const { user } = this.props;
    return (
      <NavInvisibleOnPrint>
        <Container>
          <NavbarBrand>
            <NavbarItem>
              <Link to="/">
                <img className="mainLogo" src={mainLogo} alt="" />
              </Link>
            </NavbarItem>
            <NavbarBurger onClick={this.toggleActive} />
          </NavbarBrand>

          <NavbarMenu isActive={active && window.innerWidth < 1024}>
            <NavbarStart />
            <NavbarEnd>
              <Conditional check={user.admin === 'admin'}>
                <NavbarItem hasDropdown={true} isHoverable={true}>
                  <Link to="/admin/general" className="navbar-item">
                    Admin
                  </Link>
                  <NavbarDropdown isBoxed={true}>
                    <NavbarItem>
                      <Link to="/admin/dog">Manage Dog Options</Link>
                    </NavbarItem>
                    <NavbarItem>
                      <Link to="/admin/cat">Manage Cat Options</Link>
                    </NavbarItem>
                    <NavbarItem>
                      <Link to="/admin/specialNeeds/dog">Manage Dog Special Needs</Link>
                    </NavbarItem>
                    <NavbarItem>
                      <Link to="/admin/specialNeeds/cat">Manage Cat Special Needs</Link>
                    </NavbarItem>
                    <NavbarItem>
                      <Link to="/admin/customContent">Manage Custom Content</Link>
                    </NavbarItem>
                  </NavbarDropdown>
                </NavbarItem>
              </Conditional>

              <NavbarItem>
                <Link to="/evaluations">Evaluations</Link>
              </NavbarItem>

              <NavbarItem hasDropdown={true} isHoverable={true}>
                <Link to="/stats/report" className="navbar-item">
                  Statistics
                </Link>
                <NavbarDropdown isBoxed={true}>
                  <Conditional check={user.admin === 'power' || user.admin === 'admin'}>
                    <NavbarItem>
                      <Link to="/stats/report">Generate Report</Link>
                    </NavbarItem>
                  </Conditional>
                  <NavbarItem>
                    <Link to="/stats/live/dog">Live Data (dogs)</Link>
                  </NavbarItem>
                  <NavbarItem>
                    <Link to="/stats/live/cat">Live Data (cats)</Link>
                  </NavbarItem>
                  <NavbarItem>
                    <Link to="/stats/medical">View Medical Data</Link>
                  </NavbarItem>
                  <NavbarItem>
                    <Link to="/stats/editEnrichments">
                      <Conditional
                        check={user.admin === 'power' || user.admin === 'admin'}
                        alt={<p>"View Today's Enrichments"</p>}
                      >
                        <p>{`Edit Today's Enrichments`}</p>
                      </Conditional>
                    </Link>
                  </NavbarItem>
                </NavbarDropdown>
              </NavbarItem>

              <NavbarItem>
                <Link to="/">Enrichment List Directory</Link>
              </NavbarItem>

              <Conditional check={user.admin === 'power' || user.admin === 'admin'}>
                <NavbarItem isHoverable={true} hasDropdown={true}>
                  <Link className="navbar-item" to="/manageAnimals/animalList">
                    Manage Animals
                  </Link>
                  <NavbarDropdown isBoxed={true}>
                    <NavbarItem>
                      <Link to="/manageAnimals/locations">Manage Locations</Link>
                    </NavbarItem>
                    <NavbarItem>
                      <Link to="/manageAnimals/addAnimal">Add New Animal</Link>
                    </NavbarItem>
                  </NavbarDropdown>
                </NavbarItem>
              </Conditional>

              <Conditional check={user.loggedIn}>
                <NavbarItem>
                  <NoButton onClick={user.logOut}>Log Out of {user.email}</NoButton>
                </NavbarItem>
              </Conditional>
            </NavbarEnd>
          </NavbarMenu>
        </Container>
      </NavInvisibleOnPrint>
    );
  }
}

export default Nav;
